(() => {
  'use strict';

  if (window.famiphotoLineTrackingInstalled) return;
  window.famiphotoLineTrackingInstalled = true;

  const isFamiphotoLine = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      return url.protocol === 'https:' && (
        (url.hostname === 'page.line.me' && url.pathname.replace(/\/$/, '') === '/479jyzmf') ||
        (url.hostname === 'lin.ee' && url.pathname.replace(/\/$/, '') === '/qCDIPl6')
      );
    } catch (_) {
      return false;
    }
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || !event.target || typeof event.target.closest !== 'function') return;
    const anchor = event.target.closest('a[href]');
    if (!anchor || !isFamiphotoLine(anchor.href)) return;

    if (typeof window.gtag !== 'function') return;

    const source = anchor.closest('[data-fpg-placement]');
    const placement = source ? source.getAttribute('data-fpg-placement') : (
      document.body.classList.contains('template-page') ? 'page_content' : 'site_content'
    );
    try {
      const published = window.gtag('event', 'famiphoto_line_click', {
        send_to: 'G-D910Q14RGN',
        brand: 'famiphoto_kansai',
        placement: placement,
        page_type: document.body.className.split(/\s+/).find((name) => name.indexOf('template-') === 0) || 'unknown'
      });
      if (published && typeof published.catch === 'function') published.catch(() => {});
    } catch (_) {}
  });
})();
